import React, { Component } from 'react';

export default class FileIcon extends Component {
    render() {
        return (
            <svg version="1.1" width="15px" viewBox="0 0 182.1 221">
                <g fill="#333333">
                    <path
                        className="st0"
                        d="M182.1,68.9c0-0.3,0-0.6-0.1-1c0,0,0-0.1,0-0.1c-0.1-0.3-0.1-0.6-0.2-0.8c0-0.1-0.1-0.2-0.1-0.3 c-0.1-0.2-0.2-0.4-0.3-0.6c0-0.1-0.1-0.2-0.1-0.2c-0.2-0.3-0.4-0.5-0.6-0.8L118.4,1.7c-0.2-0.2-0.5-0.4-0.8-0.6 c-0.1-0.1-0.2-0.1-0.2-0.2c-0.2-0.1-0.4-0.3-0.7-0.4c-0.1,0-0.2-0.1-0.2-0.1c-0.3-0.1-0.6-0.2-0.9-0.3c0,0,0,0-0.1,0 C115.2,0,114.9,0,114.6,0c0,0-0.1,0-0.1,0H29.7C13.3,0,0,13.3,0,29.7v161.6C0,207.6,13.3,221,29.7,221h122.6 c16.3,0,29.7-13.3,29.8-29.6L182.1,68.9C182.1,69,182.1,69,182.1,68.9z M120,19l43.5,44.5h-29.4c-7.8,0-14.2-6.4-14.2-14.2V19z M152.3,210H29.7c-10.3,0-18.7-8.4-18.7-18.7V29.7C11,19.4,19.4,11,29.7,11H109v38.4c0,13.9,11.3,25.2,25.2,25.2h36.9v116.8 C171,201.6,162.6,210,152.3,210z"
                    />
                </g>
            </svg>
        );
    }
}
